module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-166274515-1","head":true,"anonymize":true,"respectDNT":true,"pageTransitionDelay":0},
    },{
      plugin: require('../node_modules/gatsby-plugin-twitter/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":1200,"linkImagesToOriginal":true,"tracedSVG":true,"showCaptions":true,"withWebp":true}},{"resolve":"gatsby-remark-responsive-iframe"},{"resolve":"gatsby-remark-embedder"},{"resolve":"gatsby-remark-vscode"},{"resolve":"gatsby-remark-copy-linked-files","options":{"destinationDir":"linked","ignoreFileExtensions":["png","jpg","jpeg","bmp","tiff"]}}],"remarkPlugins":[null,null]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Tech Blog SMC","short_name":"techblog-smc","start_url":"/","background_color":"#e31d1b","theme_color":"#e31d1b","display":"minimal-ui","icon":"src/images/smc-square.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
